import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { addNotification } from 'actions/globalActions';

import Label from 'components/common/Label';
import DropDown from 'components/common/Dropdown';
import Button from 'components/common/Button';

import './styles.scss';

const StopwordsTableRowForm = ({ stopword, labels, onSubmitForm }) => {

  const dispatch = useDispatch();

  // form values
  const [selectedLabel, setSelectedLabel] = useState({
    id: stopword.labelId,
    name: stopword.labelName,
    color: stopword.labelColor,
  });

  console.log('safewords inside row form:', stopword);

  const [selectedStopword, setSelectedStopword] = useState(stopword.stopword);
  const [safewords, setSafewords] = useState(stopword.safewords);
  const [newSafeword, setNewSafeword] = useState('');
  const [labelFilter, setLabelFilter] = useState('');

  const handleStopwordChange = (e) => {
    const { value } = e.target;
    setSelectedStopword(value);
  };

  const validateName = (name) => {
    if (name.length === 0) {
      return {
        type: 'warning',
        title: 'Invalid Stopword',
        description: 'Stopword field cannot be empty'
      };
    }
    return null;
  };

  const validateSafeword = (word) => {
    if (word.length === 0) {
      return {
        type: 'warning',
        title: 'Invalid Safeword',
        description: 'Safeword cannot be empty'
      };
    }
    return null;
  };

  const handleNewSafeword = (e) => {
    const {value} = e.target;
    setNewSafeword(value);
  };

  const handleAddNewSafeword = (e) => {
    e.preventDefault();
    const error = validateSafeword(newSafeword);
    console.log('error:', error);
    if (error === null) {
      const word = [...safewords, newSafeword.trim()];
      console.log(word);
      setSafewords(word);
      setNewSafeword('');
    } else {
      dispatch(addNotification(error));
    }
  };

  const handleRemoveSafeword = (index) => {
    console.log(index);
    safewords.splice(index, 1);
    setSafewords([...safewords]);
  };

  const submitForm = () => {
    const validationErrors = [validateName(selectedStopword)].filter(e => e !== null);
    if (validationErrors.length === 0) {
      onSubmitForm({
        stopword: selectedStopword,
        safewords: safewords,
        labelId: selectedLabel.id,
      });
    } else {
      dispatch(addNotification(validationErrors[0]));
    }
  };

  const getLabelOptions = () =>
    labels
      .filter(({ name }) => name.toLowerCase().startsWith(labelFilter.toLowerCase()))
      .map(({ id, color, name }) => (
        <a
          href="#"
          className="dropdown-item has-text-left"
          key={id}
          onMouseDown={() => setSelectedLabel({ id, color, name })}
        >
          <Label
            color={color}
          >
            {name}
          </Label>
        </a>
      ));

  const handleLabelFilterChange = (e) => {
    const { value } = e.target;
    setLabelFilter(value);
  };

  return (
    <div className="control">
      <div className="field">
        <label className="label">Stopword</label>
        <input
          className="input"
          name="name"
          type="text"
          value={selectedStopword}
          onChange={handleStopwordChange}
        />
        <p className="help">Input exact string for matching</p>
      </div>

      <div className="field">
        <label className="label">Label</label>
        <Label
          deletable={selectedLabel.name ? true : false}
          onDelete={() => setSelectedLabel({})}
          color={selectedLabel.color ? selectedLabel.color : 'grey'}
        >
          {selectedLabel.name ? selectedLabel.name : 'No Label'}
        </Label>
        <DropDown className="is-pulled-right">
          <div className="field px-2">
            <p className="control has-icons-left">
              <input
                className="input is-small"
                type="text"
                placeholder="Search labels"
                value={labelFilter}
                onChange={handleLabelFilterChange}
              />
              <span className="icon is-small is-left">
                <i className="fas fa-search"></i>
              </span>
            </p>
          </div>
          {getLabelOptions()}
        </DropDown>
        <p className="help">Choose an existing label or leave blank</p>
      </div>

      <div className="field">
        <label className="label">Safewords</label>
        <form onSubmit={handleAddNewSafeword}>
          <input
            className="input"
            name="DNS name"
            type="text"
            value={newSafeword}
            onChange={handleNewSafeword}
          />
          <Button>Add Safeword</Button>
        </form>
        <div className="columns m-1">
          <div className="column">
            <ul>
              {safewords.map((item, index) => (
                <li key={index} className="mb-2">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="column">
            <ul>
              {safewords.map((item, index) => (
                <li key={index} className="mb-2">
                  <Button size="small" type="outlined" rounded={true} onClick={() => handleRemoveSafeword(index)} >X</Button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <Button className="is-pulled-right" type="text" onClick={submitForm}>
        Save Changes
      </Button>
    </div>
  );
};

StopwordsTableRowForm.propTypes = {
  stopword: PropTypes.shape({
    id: PropTypes.string,
    stopword: PropTypes.string,
    safewords: PropTypes.array,
    labelId: PropTypes.string,
    labelName: PropTypes.string,
    labelColor: PropTypes.string
  }),
  labels: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    color: PropTypes.string
  })),
  onSubmitForm: PropTypes.func,
};

export default StopwordsTableRowForm;

